import { string, object, number, date, mixed } from 'yup';

import {
  SLOT_VIP_TASK_ITEM_TYPES,
  VipTaskItemTypesEnum,
  VipTaskItemUserIdentifierTypesEnum,
  YUP_ERRORS_MESSAGES,
} from '@shared/constants';

const isSlotTaskItemType = (type: VipTaskItemTypesEnum) => SLOT_VIP_TASK_ITEM_TYPES.includes(type);

export const vipTaskItemValidationSchema = object().shape({
  title: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  description: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  type: mixed().oneOf(Object.values(VipTaskItemTypesEnum)).required(YUP_ERRORS_MESSAGES.REQUIRED),
  reward: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  order: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  userIdentifierType: mixed().oneOf(Object.values(VipTaskItemUserIdentifierTypesEnum)),
  completedTasksCount: number(),
  joinedTournamentsCount: number(),
  joinedTournamentsStartDate: date(),
  gameId: string().when('type', ([type], gameIdSchema) => {
    if (isSlotTaskItemType(type)) {
      return gameIdSchema.trim().required(YUP_ERRORS_MESSAGES.REQUIRED);
    } else {
      return gameIdSchema;
    }
  }),
  betLimit: number().when('type', ([type], betLimitSchema) => {
    if (isSlotTaskItemType(type)) {
      return betLimitSchema.required(YUP_ERRORS_MESSAGES.REQUIRED).min(1, 'Bet limit must be greater than 0');
    } else {
      return betLimitSchema;
    }
  }),
  taskX: number().when('type', ([type], taskXSchema) => {
    if (type === VipTaskItemTypesEnum.SLOT_HIT_X || type === VipTaskItemTypesEnum.SLOT_COUNT_HIT_X) {
      return taskXSchema.required(YUP_ERRORS_MESSAGES.REQUIRED).min(1, 'Task X value must be greater than 0');
    } else {
      return taskXSchema;
    }
  }),
  lowerRangeX: number().when('type', ([type], lowerRangeXSchema) => {
    if (type === VipTaskItemTypesEnum.SLOT_SPECIFIC_X) {
      return lowerRangeXSchema
        .required(YUP_ERRORS_MESSAGES.REQUIRED)
        .min(1, 'Lower range X value must be greater than 0');
    } else {
      return lowerRangeXSchema;
    }
  }),
  upperRangeX: number().when('type', ([type], upperRangeXSchema) => {
    if (type === VipTaskItemTypesEnum.SLOT_SPECIFIC_X) {
      return upperRangeXSchema
        .required(YUP_ERRORS_MESSAGES.REQUIRED)
        .min(1, 'Upper range X value must be greater than 0');
    } else {
      return upperRangeXSchema;
    }
  }),
  lowerLimitX: number().when('type', ([type], lowerLimitXSchema) => {
    if (type === VipTaskItemTypesEnum.SLOT_SUM_X) {
      return lowerLimitXSchema
        .required(YUP_ERRORS_MESSAGES.REQUIRED)
        .min(1, 'Lower limit X value must be greater than 0');
    } else {
      return lowerLimitXSchema;
    }
  }),
  totalTaskX: number().when('type', ([type], totalTaskXSchema) => {
    if (type === VipTaskItemTypesEnum.SLOT_SUM_X) {
      return totalTaskXSchema
        .required(YUP_ERRORS_MESSAGES.REQUIRED)
        .min(1, 'Total task X value must be greater than 0');
    } else {
      return totalTaskXSchema;
    }
  }),
  countTaskX: number().when('type', ([type], countTaskXSchema) => {
    if (type === VipTaskItemTypesEnum.SLOT_COUNT_HIT_X) {
      return countTaskXSchema
        .required(YUP_ERRORS_MESSAGES.REQUIRED)
        .min(1, 'Count task X value must be greater than 0');
    } else {
      return countTaskXSchema;
    }
  }),
});
